import { tw } from "@careinfo/tailwind";
import { yupResolver } from "@hookform/resolvers/yup";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import APIS from "../../constant/Endpoint";
import usePostHook from "../../customHooks/usePostHook";
import { createAccount } from "../../validation/AccountInfo";
import Button from "../Reusable/Button";
import AccountInfoForm from "./AccountForm";

const CreateAccount = (props: any) => {
  const { setOpenAccountPopup } = props;
  const [isactive, setIsActive] = useState("credit");
  const {
    control,
    register,
    setValue,
    getValues,
    clearErrors,
    formState: { errors },
    handleSubmit,
    watch,
    setError,
  } = useForm<any>({
    resolver: yupResolver(createAccount),
    defaultValues: async () => {
      return {
        balance_type: "credit",
      };
    },
  });
  useEffect(() => {
    setValue("balance_type", isactive);
  }, [isactive]);

  const { mutateAsync, isPostLoading } = usePostHook({
    queryKey: ["account-info"],
    navigateURL: "/accounting/account",
  });

  const handleCreate = async (values: any, setError: any) => {
    const url = APIS.COA;
    const formData = {
      ...values,
      is_group: false,
    };
    try {
      const res = await mutateAsync({ url, formData, setError });
      if (res?.status === 201) {
        setOpenAccountPopup((prev) => !prev);
      }
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <form
      onSubmit={handleSubmit((data) => handleCreate(data, setError))}
      autoComplete="off"
    >
      <AccountInfoForm
        control={control}
        register={register}
        errors={errors}
        setValue={setValue}
        getValues={getValues}
        clearErrors={clearErrors}
        isactive={isactive}
        watch={watch}
        setIsActive={setIsActive}
      />
      <div className={tw`mt-4 w-full px-4 `}>
        <div className={tw`w-32 ml-auto`}>
          <Button label="Create" isLoading={isPostLoading} />
        </div>
      </div>
    </form>
  );
};

export default CreateAccount;
